var AdjustmentDetailsAdjustmentType = /* @__PURE__ */ ((AdjustmentDetailsAdjustmentType2) => {
  AdjustmentDetailsAdjustmentType2[AdjustmentDetailsAdjustmentType2["Adjustment"] = 1] = "Adjustment";
  AdjustmentDetailsAdjustmentType2[AdjustmentDetailsAdjustmentType2["Holdback"] = 2] = "Holdback";
  AdjustmentDetailsAdjustmentType2[AdjustmentDetailsAdjustmentType2["SRP"] = 3] = "SRP";
  return AdjustmentDetailsAdjustmentType2;
})(AdjustmentDetailsAdjustmentType || {});
export {
  AdjustmentDetailsAdjustmentType
};
